import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pb-24 pt-48">
      <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Terms & Conditions
          </h1>
          <p className="text-sm mb-12 opacity-70">Effective Date: April 2026</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <p>
              Welcome to Ricky's Bees. By accessing or using our website, you agree to the following Terms & Conditions.
            </p>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>1. General</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>These Terms apply to all users of the Ricky's Bees website and customers purchasing our products.</li>
                <li>We reserve the right to update these Terms at any time.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>2. Products</h2>
              <p className="mb-4">We specialise in natural honey products sourced from Victoria.</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>All products are subject to availability</li>
                <li>We make every effort to ensure accurate product descriptions</li>
                <li>Natural products may vary in colour, texture and flavour due to seasonal and floral differences</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Orders & Pricing</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>All prices are listed in AUD (Australian Dollars)</li>
                <li>Prices may change without notice</li>
                <li>Orders are confirmed once payment has been successfully processed</li>
                <li>We reserve the right to cancel or refuse any order</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Payment</h2>
              <p className="mb-4">We accept secure payments via trusted third-party providers (e.g., Shopify Payments, Stripe, PayPal).</p>
              <p>We do not store your payment details.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Shipping</h2>
              <p>Shipping is handled according to our Shipping Policy (see below).</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Returns & Refunds</h2>
              <p>Returns and refunds are handled in accordance with our Refund Policy (see below) and Australian Consumer Law.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>7. Australian Consumer Law</h2>
              <p className="mb-4">Nothing in these Terms excludes your rights under the Australian Consumer Law (ACL).</p>
              <p>You are entitled to a replacement or refund for a major failure and compensation for any other reasonably foreseeable loss or damage.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>8. Intellectual Property</h2>
              <p>All content on this website (including branding, images and text) is the property of Ricky's Bees and may not be used without permission.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>9. Limitation of Liability</h2>
              <p className="mb-4">To the fullest extent permitted by law:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>We are not liable for indirect or consequential loss</li>
                <li>Our liability is limited to the purchase price of the product</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>10. Contact</h2>
              <p className="font-semibold">Ricky's Bees</p>
              <p>Email: <a href="mailto:sales@rickysbees.com.au" className="text-primary hover:underline">sales@rickysbees.com.au</a></p>
              <p>Location: Victoria, Australia</p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;
